import _ from 'underscore';

import View from './view';

const values = {};

const triggerFn = _.debounce( 
    view => view.trigger( 'search', view.$( '[type=text]' ).val() ), 
    350 );

const handlerFn = view => {
    const prev = values[view.cid] || '';
    const now = view.$( '[type=text]' ).val();
    values[view.cid] = now;

    if (prev !== now) triggerFn( view );
};

export default View.extend( {

    initialize(options = {}) {
        if (options.queryString)
            values[this.cid] = options.queryString;

        View.prototype.initialize.call( this, options );
    },

    events: {
        'keyup input': function(e) {
            if (13 == e.keyCode) {
                this.trigger( 'search:enter' );
                e.preventDefault();
            }
        },
        
        'keydown input': function(e) {
            switch (e.keyCode) {
                case 38: 
                    this.trigger( 'search:up' );
                    e.preventDefault();
                    return;
                case 40: 
                    this.trigger( 'search:down' );
                    e.preventDefault();
                    return;
            }

            // set timeout to correctly handle prev/now values
            setTimeout( () => handlerFn( this ), 0 );
        }
    },

    focus() {
        this.$( '[type=text]' ).focus();
    },

} );



// WEBPACK FOOTER //
// ./src/js/view/core.search.js